import { MgpProgressBarProps } from "./MgpProgressBar.types";

export default function MgpProgressBar({percentage, ...props}: MgpProgressBarProps) {
    
    return (
      
            <div className='progressbar-container' role="progressbar" {...props}>
                <div
                    className='progressbar-item'
                    style={{ width: percentage}}
                >
                </div>
            </div>
    
    );
 
} 